import { render, staticRenderFns } from "./ModelDevelopment.vue?vue&type=template&id=5541087a&scoped=true"
import script from "./ModelDevelopment.vue?vue&type=script&lang=js"
export * from "./ModelDevelopment.vue?vue&type=script&lang=js"
import style0 from "./ModelDevelopment.vue?vue&type=style&index=0&id=5541087a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5541087a",
  null
  
)

export default component.exports